export const PROVINCE_FILTER_TYPE = 'province';
export const ISP_FILTER_TYPE = 'isp';
export const GROUP_FILTER_TYPE = 'businessGroupID';
export const GROUP_BUSI_FILTER_TYPE = 'groupBusi';
export const PROVINCE_ISP_FILTER_TYPE = 'provinceIsp';
export const ORDER_FILTER_TYPE = 'sort';
export const ALL_FILTER_VALUE = -1;
export const ISP_REWARD_PAGE_SIZE = 120;
export const TELECOM_CODE = 1;
export const UNICOM_CODE = 2;
export const MOBILE_CODE = 5;

export const DEFAULT_GROUP_ID = 80000;
export const DEFAULT_ISP_VALUE = {
  label: '电信',
  value: [TELECOM_CODE],
};
export const DEFAULT_GROUP_VALUE = {
  label: '100M≤单线最低<200M',
  value: [DEFAULT_GROUP_ID],
};

export const ALL_OPTION = {
  label: '全部',
  value: ALL_FILTER_VALUE,
};
export const UNICOM_OPTION = {
  label: '联通',
  value: UNICOM_CODE,
};

export const MOBILE_OPTION = {
  label: '移动',
  value: MOBILE_CODE,
};

export const TELECOM_OPTION = {
  label: '电信',
  value: TELECOM_CODE,
};

export const ISP_MAP = {
  [ALL_FILTER_VALUE]: '全部',
  [TELECOM_CODE]: '电信',
  [MOBILE_CODE]: '移动',
  [UNICOM_CODE]: '联通',
};

export const ISP_OPTIONS = [TELECOM_OPTION, UNICOM_OPTION, MOBILE_OPTION];

export const ISP_OPTIONS_WITH_ALL = [ALL_OPTION, TELECOM_OPTION, UNICOM_OPTION, MOBILE_OPTION];

export const PROVINCE_OPTIONS = [
  {
    label: '北京',
    value: 1,
  },
  {
    label: '上海',
    value: 2,
  },
  {
    label: '天津',
    value: 3,
  },
  {
    label: '重庆',
    value: 4,
  },
  {
    label: '云南',
    value: 5,
  },
  {
    label: '台湾',
    value: 6,
  },
  {
    label: '吉林',
    value: 7,
  },
  {
    label: '四川',
    value: 8,
  },
  {
    label: '安徽',
    value: 9,
  },
  {
    label: '山东',
    value: 10,
  },
  {
    label: '山西',
    value: 11,
  },
  {
    label: '广东',
    value: 12,
  },
  {
    label: '江苏',
    value: 13,
  },
  {
    label: '江西',
    value: 14,
  },
  {
    label: '河北',
    value: 15,
  },
  {
    label: '河南',
    value: 16,
  },
  {
    label: '浙江',
    value: 17,
  },
  {
    label: '海南',
    value: 18,
  },
  {
    label: '湖北',
    value: 19,
  },
  {
    label: '湖南',
    value: 20,
  },
  {
    label: '甘肃',
    value: 21,
  },
  {
    label: '福建',
    value: 22,
  },
  {
    label: '贵州',
    value: 23,
  },
  {
    label: '辽宁',
    value: 24,
  },

  {
    label: '陕西',
    value: 25,
  },
  {
    label: '青海',
    value: 26,
  },
  {
    label: '黑龙江',
    value: 27,
  },
  {
    label: '西藏',
    value: 28,
  },
  {
    label: '广西',
    value: 29,
  },
  {
    label: '新疆',
    value: 30,
  },
  {
    label: '宁夏',
    value: 31,
  },
  {
    label: '内蒙古',
    value: 32,
  },
  {
    label: '香港',
    value: 33,
  },
  {
    label: '澳门',
    value: 34,
  },
];

export const PROVICNE_MAP = {
  1: '北京',
  2: '上海',
  3: '天津',
  4: '重庆',
  5: '云南',
  6: '台湾',
  7: '吉林',
  8: '四川',
  9: '安徽',
  10: '山东',
  11: '山西',
  12: '广东',
  13: '江苏',
  14: '江西',
  15: '河北',
  16: '河南',
  17: '浙江',
  18: '海南',
  19: '湖北',
  20: '湖南',
  21: '甘肃',
  22: '福建',
  23: '贵州',
  24: '辽宁',
  25: '陕西',
  26: '青海',
  27: '黑龙江',
  28: '西藏',
  29: '广西',
  30: '新疆',
  31: '宁夏',
  32: '内蒙古',
  33: '香港',
  34: '澳门',
};

export const PROVINCE_OPTIONS_WITH_ALL = [ALL_OPTION, ...PROVINCE_OPTIONS];

export const DEFAULT_REGION_CHART_OPTION = {
  [ISP_FILTER_TYPE]: TELECOM_CODE,
  [GROUP_FILTER_TYPE]: DEFAULT_GROUP_ID,
};
// 降序
export const DESC_ORDER = 0;
// 升序
export const ASCE_ORDER = 1;
export const REGION_PAGE_SIZE = 20;
export const DEFAULT_REGION_LIST_OPTION = {
  [GROUP_BUSI_FILTER_TYPE]: [-1, -1],
  [PROVINCE_ISP_FILTER_TYPE]: [-1, -1],
  [ORDER_FILTER_TYPE]: DESC_ORDER,
  // page: 1,
  // pageSize: REGION_PAGE_SIZE,
};

export const DEFAULT_CHART_ITEM = {
  areaReward: 0,
  highRewardList: [],
  level: 0,
};

export const GROUP_BUSI_FILTER_NAME = '定向业务';
export const PROVINCE_ISP_FILTER_NAME = '省份/运营商';
